function NotFound() {
    return (
    <>
        <h3>404 Not Found</h3>
        <a href="/">Go home</a>
    </>
    )
}

export default NotFound;